module.exports = __webpack_public_path__ + "static/img/roleInfo.a27fc05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_1/roleInfo.png
// module id = jg6U
// module chunks = 1